import { setAnswer, setLoading } from "../slices/gameSlice";
import { LetterState } from "../../redux/slices/gameSlice";
// Wordle API fetch thunk
export const fetchWordOfTheDay = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading(true));
    const res = await fetch("https://words.dev-apis.com/word-of-the-day");
    if (!res.ok) {
      throw new Error(`Failed to fetch word: ${res.status} ${res.statusText}`);
    }
    const data = await res.json();
    dispatch(setAnswer(data.word.toUpperCase()));
  } catch (err) {
    console.error("Failed to fetch word:", err);
  }
};
